import { render, staticRenderFns } from "./ProductProfile.vue?vue&type=template&id=2dbbb2cc&"
import script from "./ProductProfile.vue?vue&type=script&lang=js&"
export * from "./ProductProfile.vue?vue&type=script&lang=js&"
import style0 from "./ProductProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports